import { shape, string, number } from 'prop-types';

export const basePriceShape = shape({
    as_string: string,
    decimal: string,
    integer: string,
});

const vatsShape = shape({
    with_vat: basePriceShape,
    without_vat: basePriceShape,
});

export const deliveryOffersShape = shape({
    min_fee: basePriceShape,
    min_fee_time: number,
    min_time: number,
    min_time_fee: basePriceShape,
});

export const priceShape = shape({
    actual_price: vatsShape.isRequired,
    legact_unit: string,
    retail_price: vatsShape,
    unit: string,
    ecopart: string,
});
